import { render, staticRenderFns } from "./bloodCollection.vue?vue&type=template&id=1ffc4746&scoped=true&"
import script from "./bloodCollection.vue?vue&type=script&lang=js&"
export * from "./bloodCollection.vue?vue&type=script&lang=js&"
import style0 from "./bloodCollection.vue?vue&type=style&index=0&id=1ffc4746&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffc4746",
  null
  
)

export default component.exports